export default (
    element: globalThis.Ref<HTMLElement | null, HTMLElement | null>
) => {
    return new Promise(resolve => {
        const interval = setInterval(() => {
            if (element.value) {
                clearInterval(interval)
                resolve(element.value)
            }
        }, 50)
    })
}
